import React from 'react';
import { isMobile } from '@pascal/pascal-core';

import { fightersList } from '../../../enums/uiConfig';

export const TutorialCashOutHeader = ({ tutorialData, t, tutorialStep }) => {
  return (
    <div className='bet-top-row tab-states'>
      <div className='bet-fighter-head-row type-2'>
        <div className={`cash-out-row-inner ${tutorialStep !== 2 ? 'inactive' : ''}`}>
          {tutorialData.map((item) => (
            //  ADD CLASS " orange-type, green-type, pink-type, disabled, state-try-again "
            <div
              className={`cash-tabs ${
                tutorialStep === 2 && item !== 1
                  ? 'state-try-again'
                  : tutorialData === 2 && item === 1
                  ? fightersList[item].jetColor
                  : ''
              } ${tutorialStep !== 2 && !isMobile() ? 'disabled' : ''} ${
                isMobile() ? fightersList[item].jetColor : ''
              }`}
              key={item}
            >
              <div className='tabs-line' />
              <span className='fighter-top-btn-text'>{t(fightersList[item].jetName)}</span>
              <i className='fighters-x-icon' />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
